const permissions = {
  'cerberus:admin': 'admin',
  'warehouse:returnagents': 'return_agent',
  'warehouse:manager': 'return_manager',
  'warehouse:returnsupervisors': 'return_manager',
  'CS:manager': 'cx_manager',
  'CS:supervisor': 'cx_manager',
  'CS:teamleader': 'cx_manager',
  'CS:senior_agent': 'cx_agent',
  'CS:junior_agent': 'cx_agent'
};

const setUserAccess = (accessToken, accesses) => {
  const permissionsTags = accessToken['http://cerberus.altitude-sports.com/groups'].concat(
    accessToken['http://cerberus.altitude-sports.com/roles']
  );

  const tags = permissionsTags.map(el => permissions[el]).filter(el => el);

  if (accesses.includes('all')) {
    return true;
  } else {
    return tags.find(el => accesses.includes(el)) ? true : false;
  }
};

export default setUserAccess;
